export const showAsMap = {
  'touchone-calendar': [
    {
      key: 'reservationPopup.free',
      value: 'free',
    },
    {
      key: 'reservationPopup.busy',
      value: 'busy',
    },
  ],
  ews: [
    {
      key: 'reservationPopup.free',
      value: 'free',
    },
    {
      key: 'reservationPopup.tentative',
      value: 'tentative',
    },
    {
      key: 'reservationPopup.busy',
      value: 'busy',
    },
    {
      key: 'reservationPopup.workingElsewhere',
      value: 'workingelsewhere',
    },
    {
      key: 'reservationPopup.away',
      value: 'oof',
    },
  ],
  o365: [
    {
      key: 'reservationPopup.free',
      value: 'free',
    },
    {
      key: 'reservationPopup.tentative',
      value: 'tentative',
    },
    {
      key: 'reservationPopup.busy',
      value: 'busy',
    },
    {
      key: 'reservationPopup.workingElsewhere',
      value: 'workingElsewhere',
    },
    {
      key: 'reservationPopup.away',
      value: 'oof',
    },
  ],
  gspace: [
    {
      key: 'reservationPopup.free',
      value: 'transparent',
    },
    {
      key: 'reservationPopup.busy',
      value: 'opaque',
    },
  ],
};
